export default {
  stream_from_phone: 'stream_from_phone',
  other_webrtc: 'other_webrtc',
  // multihost: 'multihost',
  peer2peer: 'peer2peer',
  conference: 'conference'
}
